import { render } from "./ChatMessageContent.vue?vue&type=template&id=413ae35c&scoped=true"
import script from "./ChatMessageContent.vue?vue&type=script&lang=js"
export * from "./ChatMessageContent.vue?vue&type=script&lang=js"

import "./ChatMessageContent.vue?vue&type=style&index=0&id=413ae35c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413ae35c"]])

export default __exports__